import api from "../helpers/util";

export const killRegister = (data, signal) =>
  api.post("/nlis/kill_register", data, { signal });

export const erpEnquiry = async (data, signal) => {
  try {
    const response = await api.post("/nlis/erp_enquiry", data, { signal });
    console.log("erp enquiry", response?.data?.result);
    return response;
  } catch (error) {
    if (error.name === "CanceledError" || error.code === "ERR_CANCELED") throw error;
    throw new Error("Error fetching Pic status", error);
  }
};

export const deviceStatus = async (data) => {
  try {
    const response = await api.post("/nlis/device_status", data);
    console.log("device status", response?.data?.result);
    return response;
  } catch (error) {
    throw new Error("Error fetching device status ", error);
  }
};

export const getNlisHoldings = async () => {
  try {
    const response = await api.get("/nlis/holdings");
    return response;
  } catch (error) {
    throw new Error("Error fetching NLIS holdings", error);
  }
};

export const refreshNlisHoldings = async () => {
  try {
    const response = await api.post("/nlis/holdings/refresh");
    return response;
  } catch (error) {
    throw new Error("Error refreshing NLIS holdings", error);
  }
};

export const getPicExceptions = async ({ search = "", page = 1 } = {}) => {
  try {
    const params = new URLSearchParams({ page });
    if (search) params.append("search", search);
    const response = await api.get(`/nlis/erp_exceptions/pic?${params.toString()}`);
    return response;
  } catch (error) {
    throw new Error("Error fetching PIC exceptions", error);
  }
};

export const getDeviceExceptions = async ({ search = "", page = 1 } = {}) => {
  try {
    const params = new URLSearchParams({ page });
    if (search) params.append("search", search);
    const response = await api.get(`/nlis/erp_exceptions/devices?${params.toString()}`);
    return response;
  } catch (error) {
    throw new Error("Error fetching device exceptions", error);
  }
};

export const refreshPicExceptions = async () => {
  try {
    const response = await api.post("/nlis/erp_exceptions/refresh/pic");
    return response;
  } catch (error) {
    throw new Error("Error refreshing PIC exceptions", error);
  }
};

export const getLatestKillRegisterDate = async () => {
  try {
    const response = await api.get("/nlis/kill_register/latest_date");
    return response.data;
  } catch (error) {
    throw new Error("Error fetching latest kill register date", error);
  }
};

export const updateKillRegisterBody = async (payload) =>
  api.put("/nlis/kill_register/body", payload);

export const getNlisFeatures = () => api.get("/nlis/features");